import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {OfferFormBase} from '../offer-form-base/offer-form-base.component';
import {Offer} from '../../../../../model/offer/offer';
import {QuestionOptions} from '../../../../../constants/question-options';
import {Observable, of, ReplaySubject, takeUntil} from 'rxjs';
import {OfferFileUploadComponent} from '../offer-file-upload/offer-file-upload.component';

@Component({
    selector: 'app-individual-information-form',
    templateUrl: './individual-information-form.component.html',
    styleUrls: ['../../../../../../styles/form-input.scss'],
    providers: [{ provide: OfferFormBase, useExisting: IndividualInformationFormComponent }],
    standalone: false
})
export class IndividualInformationFormComponent extends OfferFormBase implements OnInit {
  @Output() uploadInProgress = new EventEmitter<boolean>();
  QuestionOptions = QuestionOptions;
  defaultTerms: string[] = QuestionOptions.defaultTerms;
  public filterCtrlDefaultTerms: FormControl<string> = new FormControl<string>('');
  public filteredOptionsDefaultTerms: ReplaySubject<string[]> = new ReplaySubject<string[]>(1);
  defaultClauses: string[] = QuestionOptions.defaultClauses;
  public filterCtrlDefaultClauses: FormControl<string> = new FormControl<string>('');
  public filteredOptionsDefaultClauses: ReplaySubject<string[]> = new ReplaySubject<string[]>(1);


  @ViewChild(OfferFileUploadComponent) offerFileUpload: OfferFileUploadComponent;


  constructor(private readonly fb: FormBuilder) {
    super();
  }

  ngOnInit() {
    this.filteredOptionsDefaultTerms.next(this.defaultTerms.slice());
    this.filterCtrlDefaultTerms.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.filterTerms(this.filterCtrlDefaultTerms.value, this.defaultTerms, this.filteredOptionsDefaultTerms);
      });
    this.filteredOptionsDefaultClauses.next(this.defaultClauses.slice());
    this.filterCtrlDefaultClauses.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.filterTerms(this.filterCtrlDefaultClauses.value, this.defaultClauses, this.filteredOptionsDefaultClauses);
      });
  }

  filterTerms(search: string, options, filtered) {
    if (!options) {
      return;
    }
    if (!search) {
      filtered.next(options.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    filtered.next(
      options.filter(defaultTerms => defaultTerms.toLowerCase().indexOf(search) > -1)
    );
  }

  formGroup = this.fb.group({
    defaultTerms: new FormControl(null),
    individualTerms: '',
    defaultClauses: new FormControl(null),
    individualClauses: '',
    otherInformation: '',
  });

  updateOffer(offer: Offer): void {
    offer.standardTermsAndConditions = this.formGroup.value.defaultTerms;
    offer.individualTermsAndConditions = this.formGroup.value.individualTerms;
    offer.standardClauses = this.formGroup.value.defaultClauses;
    offer.individualClauses = this.formGroup.value.individualClauses;
    offer.otherInformation = this.formGroup.value.otherInformation;
  }

  override validStatus(): Observable<boolean> {
    return of(true);
  }

  sendUploadStatus(data: boolean) {
    this.uploadInProgress.emit(data);
  }

  prefill(offer: Offer) {
    this.formGroup.patchValue({
      defaultTerms: offer.standardTermsAndConditions ?? null,
      individualTerms: offer.individualTermsAndConditions ?? '',
      defaultClauses: offer.standardClauses ?? null,
      individualClauses: offer.individualClauses ?? '',
      otherInformation: offer.otherInformation ?? '',
    });
  }
}
